import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useState } from 'react';
import { PermissionService } from '../../services/permission.service';
import { toast } from 'react-toastify';

const titleStyles = {
  color: '#000000',
  fontSize: '1.25rem',
  fontWeight: 'bold',
  textAlign: 'start',
};

const useStyles = makeStyles((theme) => ({
  danger: {
    color: 'black',
    fontWeight: '500',
  },
}));

const toastConfig = {
  position: 'bottom-right',
  hideProgressBar: true,
};

export function ConfirmDeleteUser({
  openDialog = false,
  setOpenDialog,
  user = {},
  refreshUsers,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await PermissionService.deleteUser(user.email);
      refreshUsers();
      toast('Usuário excluido!', toastConfig);
    } catch (e) {
      toast('Erro ao excluir usuário!', toastConfig);
    } finally {
      setLoading(false);
      setOpenDialog(false);
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      aria-labelledby="confirm-delete-dialog-title"
    >
      <DialogTitle id="confirm-delete-dialog-title">
        <Typography style={titleStyles} component="h1" variant="subtitle1">
          Confirmar exclusão
        </Typography>
      </DialogTitle>
      <DialogContent>
        <p className={classes.danger}>
          Tem certeza de que deseja excluir o usuário{' '}
          <strong>{user?.name}</strong>? Esta ação removerá também todos os
          dados relacionados a ele e <strong>não poderá ser desfeita.</strong>
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDialog(false)} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={handleDelete} color="primary" disabled={loading}>
          {loading ? 'Excluindo...' : 'Excluir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
